import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

export interface ILoginProps {
    BrowserFingerprint: string;
    Password: string;
    UserAgent: string;
    UserName: string;
}

export interface LoginResponse {
    LoginMessage: string;
    UserID: number;
    ValidUserNamePassword: boolean;
}

export const useLogin = () =>
    useMutation<LoginResponse, unknown, ILoginProps>({
        mutationFn: async (payload: ILoginProps): Promise<LoginResponse> => {
            const axiosAuth = createAxiosClient("Auth");

            const response = await axiosAuth.post<LoginResponse>(
                "/UILogin/ValidateLogin",
                JSON.stringify(payload),
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        },
    });
